import "core-js/modules/es.array.filter";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addRealNameList, updataRealNameList } from "@/api/loginConfig/addRealNamePame";
import { allLoginSdk } from "@/api/loginConfig/loginList";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        bizid: "",
        appid: "",
        if_real_name: "",
        sdk_id: "",
        secretkey: ""
      },
      realName: [{
        id: 1,
        name: "是"
      }, {
        id: 2,
        name: "否"
      }],
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      // advchannels: [],
      pay_types: [],
      searchMark: {},
      rawData: [],
      platformList: [],
      channelList: [],
      isNum: '',
      rules: {
        game: [{
          required: true,
          message: '请选择游戏',
          trigger: 'blur'
        }],
        platform: [{
          required: true,
          message: '请选择平台',
          trigger: 'blur'
        }],
        channel: [{
          required: true,
          message: '请选择渠道',
          trigger: 'blur'
        }],
        pkg: [{
          required: true,
          message: '请选择包名',
          trigger: 'blur'
        }],
        bizid: [{
          required: true,
          message: '请输入bizid',
          trigger: 'blur'
        }],
        appid: [{
          required: true,
          message: '请输入appid',
          trigger: 'blur'
        }],
        if_real_name: [{
          required: true,
          message: '请选择',
          trigger: 'blur'
        }],
        secretkey: [{
          required: true,
          message: '请输入secretkey',
          trigger: 'blur'
        }],
        sdk_id: [{
          required: true,
          message: '请输入sdk_id',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {// searchgame().then((res) => {
    //   this.searchgames = res.data;
    // });
  },
  methods: {
    getInit: function getInit() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        allLoginSdk().then(function (res) {
          if (res.status == 200) {
            _this.rawData = res.data;
            _this.searchgames = _this.removeDuplicate(res.data, 'game');
            resolve();
          }
        });
      });
    },
    removeDuplicate: function removeDuplicate(arr, type) {
      var map = new Map();
      return arr.filter(function (v) {
        return !map.has(v[type]) && map.set(v[type], 1);
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        bizid: "",
        appid: "",
        if_real_name: "",
        sdk_id: "",
        secretkey: ""
      };
      this.platformList = [];
      this.channelList = [];
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.$refs.ruleForm.resetFields();
    },
    OffmOD: function OffmOD() {
      this.dialogFormVisible = false;
      this.clearData();
    },
    init: function init(data, type) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isNum = type;
                _this2.searchData = _objectSpread(_objectSpread({}, _this2.searchData), data);
                _context.next = 4;
                return _this2.getInit();

              case 4:
                if (!data) {
                  _context.next = 11;
                  break;
                }

                _context.next = 7;
                return _this2.gamechange(data.game, true);

              case 7:
                _context.next = 9;
                return _this2.platformchange(data.platform, true);

              case 9:
                _context.next = 11;
                return _this2.channelchange(data.channel, true);

              case 11:
                _this2.dialogFormVisible = true;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    gamechange: function gamechange(game_mark, cleara) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (!cleara) {
          _this3.searchData.platform = '';
          _this3.searchData.channel = '';
          _this3.searchData.pkg = '';
          _this3.searchplatforms = [];
          _this3.searchchannels = [];
          _this3.searchpkgs = [];
        }

        if (game_mark != "") {
          var list = _this3.rawData.filter(function (item) {
            return item.game == game_mark;
          });

          _this3.platformList = list;
          _this3.searchplatforms = _this3.removeDuplicate(list, 'platform');
          resolve();
        }
      });
    },
    platformchange: function platformchange(platform_mark, cleara) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (!cleara) {
          _this4.searchData.channel = '';
          _this4.searchData.pkg = '';
          _this4.searchchannels = [];
          _this4.searchpkgs = [];
        }

        if (platform_mark != "") {
          var list = _this4.platformList.filter(function (item) {
            return item.platform == platform_mark;
          });

          _this4.channelList = list;
          _this4.searchchannels = _this4.removeDuplicate(list, 'channel');
          resolve();
        }
      });
    },
    channelchange: function channelchange(channel_mark, cleara) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        if (!cleara) {
          _this5.searchData.pkg = '';
          _this5.searchpkgs = [];
        }

        if (channel_mark != "") {
          var list = _this5.channelList.filter(function (item) {
            return item.channel == channel_mark;
          });

          _this5.searchpkgs = list;
          resolve();
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this6 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this6.searchData.sdk_id = _this6.searchpkgs.filter(function (item) {
            return item.pkg == _this6.searchData.pkg;
          })[0].id;
          var reqFn = _this6.isNum == 1 ? addRealNameList : updataRealNameList;
          reqFn(_this6.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(res.message);

              _this6.OffmOD();

              if (_this6.isNum != 1) {
                _this6.$emit("refreshDataList", false);
              }
            }
          });
        }
      });
    }
  }
};